export enum ReconciliationOrderReportTypeEnum {
  RECONCILIATION = 'reconciliation',
  PAYMENT_TYPES = 'paymentTypes',
  LAST_EOD_REPORT = 'lastEodReport',
}